<mat-card class="proposal-card">

  <mat-card-actions class="actions">
    <a routerLink="/proposals">
      {{ 'dashboardPanells.propostesPresentades' | translate }}
    </a>

    <span
      class="link"
      (click)="viewAllProposals()">
      {{ 'dashboardManifestacions.veureMes' | translate }}
    </span>
  </mat-card-actions>

  <mat-card-content *ngIf="activeProposals?.length; else empty">

    <mat-list-item
      class="proposal-item"
      *ngFor="let proposal of activeProposals"
      (click)="navigateToProposal(proposal)">

      <!-- Títol -->
      <p mat-line class="title">
        {{ proposal.titol }}
      </p>

      <!-- Info -->
      <p mat-line class="meta">
        <span>{{ 'dashboardManifestacions.deadline' | translate }} {{ proposal.data_limit_presentacio }}</span>

        <span *ngIf="proposal.data_documentacio">
          {{ 'dashboardMiRequeriments.dataLimitRequeriment' | translate }} {{ proposal.data_documentacio }}
        </span>

        <span *ngIf="proposal.coordinador_nom">
          {{ 'dashboardMiRequeriments.coordinacio' | translate }} {{ proposal.coordinador_nom }}
        </span>
      </p>

      <!-- Tipus incidència -->
      <p *ngIf="proposal.tipus_incidencia" class="incidencia">
        {{ proposal.tipus_incidencia }}
      </p>

      <!-- Estat + icones -->
      <div class="status-row">
        <div class="icons">
          <mat-icon
            [ngClass]="proposal.import_propi ? 'ok' : 'error'"
            [matTooltip]="proposal.import_propi ? ('dashboardMiRequeriments.importPropiToolTip' | translate:{ import: proposal.import_propi }) : ('dashboardMiRequeriments.faltaImportPropi' | translate)">
            monetization_on
          </mat-icon>
        </div>

        <span
          class="clau"
          [ngClass]="proposal.ambit_proposta">
          {{ proposal.clau }}
        </span>
      </div>

      <mat-divider></mat-divider>

    </mat-list-item>

  </mat-card-content>

  <ng-template #empty>
    <mat-card-content>
      <p>{{ 'dashboardMiRequeriments.senseManifestacions' | translate }}</p>
    </mat-card-content>
  </ng-template>

</mat-card>

<mcrit-gestio-list-resume
  class="resume"
  [dades]="resumeData"
  [titol]="'dashboardManifestacions.titolPropostesAmbit' | translate">
</mcrit-gestio-list-resume>
